export default {
  path: '/oms',
  component: (resolve) => require(['@/views/oms/index.vue'], resolve),
  redirect: '/oms/monitor-system/task-list',
  children: [
    {
      path: '/oms/monitor-system/task-list',
      component: (resolve) => require(['@/views/oms/monitor-system/task-list/index.vue'], resolve)
    },
    {
      path: '/oms/monitor-system/task-list/:taskId',
      component: (resolve) =>
        require(['@/views/oms/monitor-system/task-list/TaskDetail.vue'], resolve)
    },
    {
      path: '/oms/monitor-system/event-list',
      component: (resolve) => require(['@/views/oms/monitor-system/event-list/index.vue'], resolve)
    },
    {
      path: '/oms/monitor-system/event-list/:eventId',
      component: (resolve) =>
        require(['@/views/oms/monitor-system/event-list/EventDetail.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/routers',
      component: (resolve) => require(['@/views/oms/devices-monitor/routers/index.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/routers/:routerId',
      component: (resolve) => require(['@/views/oms/devices-monitor/routers/items.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/switches',
      component: (resolve) => require(['@/views/oms/devices-monitor/switches/index.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/switches/:switchId',
      component: (resolve) => require(['@/views/oms/devices-monitor/switches/items.vue'], resolve)
    },
    {
      path: '/oms/devices-monitor/rack-current',
      component: (resolve) =>
        require(['@/views/oms/devices-monitor/rack-current/index.vue'], resolve)
    }
  ]
};
